import * as React from "react"
import { renderSvgMarkupToDataUrl } from "../reports-helpers"

export const SvgAsImage = ({
  children,
  scale,
  ...props
}: Omit<React.PropsWithChildren<React.ImgHTMLAttributes<HTMLImageElement>>, "src" | "srcSet"> & { scale?: number }) => {
  const { svgRef, imageUrl } = useRenderSvgRefToImage(scale)

  return (
    <div
      ref={(ref) => {
        svgRef.current = ref?.getElementsByTagName("svg")[0]
      }}
    >
      {imageUrl ? <img {...props} src={imageUrl} /> : children}
    </div>
  )
}

export const useRenderSvgRefToImage = (scale?: number) => {
  const svgRef: React.MutableRefObject<SVGElement | undefined | null> = React.useRef(null)
  const { imageUrl, renderImage } = useRenderSvgToImage(scale)

  React.useEffect(() => {
    if (svgRef.current) {
      renderImage(svgRef.current)
    }
  }, [svgRef.current])

  return { imageUrl, svgRef }
}

export const useRenderSvgToImage = (scale = 1) => {
  const [imageUrl, setImageUrl] = React.useState<string>()

  return {
    imageUrl,
    async renderImage(element: SVGElement) {
      const serialized = new XMLSerializer().serializeToString(element)
      const width = element.clientWidth * scale
      const height = element.clientHeight * scale
      await renderSvgMarkupToDataUrl(serialized, width, height).then(setImageUrl)
    },
  }
}
